export let BlockChart = function (chart) {
  this.chartDiv = chart;
  this.chartWidth = this.chartDiv.clientWidth;
  this.chartHeight = this.chartDiv.clientHeight;
};

BlockChart.prototype.setParams = function (option) {
  this.option = option;
  this.data = option.data;

  this.color0 = "#EAEAEA";
  this.color1 = "#D1E0F0";
  this.lineColor = "#3663AF";
  this.circleColor = "#8C9AA5";
  this.circleFillColor = "#FFFFFF";
  this.textFillColor = "#D45F34";
  this.textColor = "#FFFFFF";

  this.mapping = new BlockChartMapping();
  this.mapping.setPadding(70, 70, 0, 43);
  this.mapping.setDrawAreaSize(this.chartWidth, this.chartHeight);
  this.mapping.dataLength = this.data.length;
  this.mapping.setDataRange(0, 0);

  this.chartDiv.style.position = "relative";

  this.viewDiv = document.createElement("div");
  this.viewDiv.style.position = "relative";
  this.viewDiv.style.width = "100%";
  this.viewDiv.style.height = "100%";
  this.chartDiv.appendChild(this.viewDiv);

  this.updateDataMinMax();

  var util = new BlockChartUtil();
  util.attachTouchEvent(this, this.viewDiv);

  this.canvas = BlockChartDrawUtil.createCanvas(
    this.viewDiv,
    this.chartWidth,
    this.chartHeight
  );
  //	this.draw();
};

BlockChart.prototype.init = function (option_list, data_list) {
  if (option_list == null || option_list.length == 0) {
    return;
  }

  for (var i = 0; i < option_list.length; i++) {
    if (this.option.option_id == parseInt(option_list[i])) {
      //			console.log(data_list[i]);
      this.mapping.setDataRange(parseInt(data_list[i][0]), data_list[i].length);
      this.mapping.updateScroll();
    }
  }
};

BlockChart.prototype.clear = function () {
  this.mapping.setDataRange(0, 0);
  this.mapping.updateScroll();
  this.draw();
};

BlockChart.prototype.draw = function () {
  BlockChartDrawUtil.clear(this.canvas);
  this.projectLine();
};

BlockChart.prototype.updateDataMinMax = function () {
  var min = 0;
  var max = null;
  for (var i = 0; i < this.data.length; i++) {
    var v = this.data[i].count;
    if (max == null || max < v) {
      max = v;
    }
  }
  this.mapping.setDataMinMax(min, max);
};

BlockChart.prototype.projectLine = function () {
  var start = this.mapping.dataRangeStartIndex;
  var end = this.mapping.dataRangeStartIndex + this.mapping.dataRangeLength;
  var cloud0 = [];
  var cloud1 = [];

  var w = this.mapping.getUnitWidth() / 2;

  for (var i = 0; i < this.data.length; i++) {
    var v = this.data[i].count;

    var x = this.mapping.transformIndex(i);
    var y = this.mapping.transformValue(v);

    cloud0.push({ x: x - w, y: y });
    cloud0.push({ x: x + w, y: y });

    if (start <= i && end > i) {
      cloud1.push({ x: x - w, y: y });
      cloud1.push({ x: x + w, y: y });
    }
  }

  if (cloud0.length > 0) {
    var x = cloud0[cloud0.length - 1].x;
    var y = this.mapping.drawAreaHeight - this.mapping.paddingBottom;
    cloud0.push({ x: x, y: y });
    cloud0.push({ x: cloud0[0].x, y: y });
  }

  BlockChartDrawUtil.pathFill(
    this.canvas,
    cloud0,
    1,
    this.color0,
    this.color0,
    1
  );
  BlockChartDrawUtil.line(
    this.canvas,
    20,
    y + 1,
    this.mapping.drawAreaWidth - 20,
    y,
    this.color0,
    3
  );

  if (cloud1.length > 0 && this.mapping.dataRangeLength > 0) {
    var x0 = cloud1[0].x;
    var x1 = cloud1[cloud1.length - 1].x;
    var y = this.mapping.drawAreaHeight - this.mapping.paddingBottom;
    cloud1.push({ x: x1, y: y });
    cloud1.push({ x: x0, y: y });

    BlockChartDrawUtil.pathFill(
      this.canvas,
      cloud1,
      1,
      this.color1,
      this.color1,
      1
    );

    y += 1;
    x0 = this.mapping.dataRangeStartX;
    x1 = this.mapping.dataRangeEndX;
    BlockChartDrawUtil.line(this.canvas, x0, y, x1, y, this.lineColor, 3);
    BlockChartDrawUtil.drawPoint(
      this.canvas,
      x0,
      y,
      this.circleColor,
      this.circleFillColor,
      9
    );
    BlockChartDrawUtil.drawPoint(
      this.canvas,
      x1,
      y,
      this.circleColor,
      this.circleFillColor,
      9
    );

    if (this.mapping.dataRangeLength == 1) {
      var t = this.data[start].name;
      t = t.replace("~", "");
      this.projectText((x0 + x1) / 2, y, t);
    } else {
      var t = "下限なし";
      if (start > 0) {
        t = this.data[start].name;
        t = t.replace("~", "");
        t = t.replace("未満", "");
        t = t.replace("以上", " ");
        t = t.split(" ")[0];
      }
      this.projectText(x0, y, t);

      t = "上限なし";
      if (end < this.data.length) {
        t = this.data[end].name;
        t = t.replace("~", "");
        t = t.replace("未満", "");
        t = t.replace("以上", " ");
        t = t.split(" ")[0];
      }
      this.projectText(x1, y, t);
    }
  }
};

BlockChart.prototype.projectText = function (x, y, text) {
  var w = BlockChartDrawUtil.measureText(this.canvas, text) + 20;
  var rect_h = 20;
  var offset = 20;

  var p = [];
  p.push({ x: x, y: y + 12 });
  p.push({ x: x - 4, y: y + offset });
  p.push({ x: x + 4, y: y + offset });
  p.push({ x: x, y: y + 12 });
  BlockChartDrawUtil.pathFill(
    this.canvas,
    p,
    1,
    this.textFillColor,
    this.textFillColor
  );

  BlockChartDrawUtil.roundRect(
    this.canvas,
    x - w / 2,
    y + offset,
    w,
    rect_h,
    5,
    this.textFillColor,
    this.textFillColor
  );
  BlockChartDrawUtil.fillText(
    this.canvas,
    x,
    y + offset + (rect_h + 10) / 2,
    text,
    this.textColor,
    "center"
  );
};

BlockChart.prototype.hitTestPanel = function (pharse, x, y) {
  var w = this.mapping.getUnitWidth() / 2;
  var x0 = this.mapping.transformIndex(0) - w;
  var x1 = this.mapping.transformIndex(this.data.length - 1) + w;

  var x_start = this.mapping.dataRangeStartX;
  var x_end = this.mapping.dataRangeEndX;
  //	var y0 = 0;
  var y1 = this.mapping.drawAreaHeight - this.mapping.paddingBottom;

  //	if(x > x0 && x < x1 && y > y0 && y < y1) {
  if (pharse == "touchstart") {
    if (this.mapping.dataRangeLength > 0 && y > y1 - 10) {
      if (Math.abs(x - x_start) < 20) {
        return "dragleft";
      } else if (Math.abs(x - x_end) < 20) {
        return "dragright";
      }
    } else if (x >= x0 && x <= x1) {
      return "up";
    }
  } else if (pharse == "touchmove") {
    if (x >= x0 && x <= x1) {
      return "move";
    }
  }
  return null;
};

BlockChart.prototype.onTouchEvent = function (target, pharse, cursorCoords) {
  var index;
  if (cursorCoords != null) {
    var hittest = this.hitTestPanel(pharse, cursorCoords.x, cursorCoords.y);
    if (hittest == null) {
      return;
    }
    var index = Math.round(this.mapping.unTransformIndex(cursorCoords.x));
    index = Math.min(Math.max(0, index), this.data.length - 1);
  }
  if (pharse == "touchstart") {
    if (hittest == "up") {
      this.panelActionIndex = index;
      this.panelActionStartIndex = index;
      this.panelActionLastIndex = index;
      this.mapping.actionStart(index);
      this.hittest = hittest;
      this.drawPanelAction(pharse);
    } else if (hittest == "dragleft" || hittest == "dragright") {
      this.scrollActionStartStatus = cursorCoords;
      this.scrollActionStartX = this.mapping.dataRangeStartX;
      this.scrollActionEndX = this.mapping.dataRangeEndX;
      this.hittest = hittest;
      this.drawPanelAction(pharse);
    }
  } else if (pharse == "touchmove") {
    if (this.hittest == null) {
      return;
    } else if (this.hittest == "up") {
      if (index != this.panelActionLastIndex) {
        this.panelActionIndex = index;
        this.panelActionLastIndex = index;
        this.drawPanelAction(pharse);
      }
    } else {
      this.scrollActionStatus = cursorCoords;
      this.drawPanelAction(pharse);
    }
  } else if (pharse == "touchend") {
    this.panelActionIndex = null;
    this.panelActionStartIndex = null;
    this.panelActionLastIndex = null;
    this.scrollActionStatus = null;
    this.hittest = null;
  }

  return true;
};

BlockChart.prototype.drawPanelAction = function (pharse) {
  var change = false;
  if (this.hittest == "up") {
    var index = this.panelActionIndex;

    var start = this.mapping.actionStartIndex;
    var end =
      this.mapping.actionStartIndex + this.mapping.actionStartLength - 1;
    //		console.log("click [" + start + "," + end + "],[" + this.panelActionStartIndex + "," + index + "]");

    this.mapping.doAction(this.panelActionStartIndex, index);
    this.mapping.updateScroll();

    if (
      start != this.mapping.dataRangeStartIndex ||
      end != this.mapping.dataRangeStartIndex + this.mapping.dataRangeLength - 1
    ) {
      //			console.log("change " + this.mapping.dataRangeStartIndex + "," + this.mapping.dataRangeLength);
      this.draw();
      change = true;
    }
  } else if (pharse == "touchmove") {
    var x = this.scrollActionStatus.x;
    if (this.hittest == "dragleft") {
      var offset = x - this.scrollActionStartStatus.x;
      var startX = this.scrollActionStartX + offset;
      startX = Math.min(
        this.mapping.dataRangeEndX - this.mapping.getUnitWidth() * 0.75,
        startX
      );
      this.mapping.dataRangeStartX = startX;
      var startIndex = Math.round(this.mapping.unTransformIndex(startX) + 0.5);
      //			console.log("scroll start:" + startIndex);
      if (startIndex != this.mapping.dataRangeStartIndex) {
        this.mapping.dataRangeLength +=
          this.mapping.dataRangeStartIndex - startIndex;
        this.mapping.dataRangeStartIndex = startIndex;
        change = true;
      }
    } else if (this.hittest == "dragright") {
      var offset = x - this.scrollActionStartStatus.x;
      var endX = this.scrollActionEndX + offset;
      endX = Math.max(
        this.mapping.dataRangeStartX + this.mapping.getUnitWidth() * 0.75,
        endX
      );
      this.mapping.dataRangeEndX = endX;
      var endIndex = Math.round(this.mapping.unTransformIndex(endX) + 0.5);
      //			console.log("scroll end:" + endIndex);
      if (
        endIndex !=
        this.mapping.dataRangeStartIndex + this.mapping.dataRangeLength
      ) {
        this.mapping.dataRangeLength =
          endIndex - this.mapping.dataRangeStartIndex;
        change = true;
      }
    }
    this.draw();
  }

  if (change) {
    this.change(
      this.option,
      this.mapping.dataRangeStartIndex,
      this.mapping.dataRangeStartIndex + this.mapping.dataRangeLength - 1
    );
  }
};

var BlockChartMapping = function () {};

BlockChartMapping.prototype.updateScroll = function () {
  var w = this.getUnitWidth() / 2;
  this.dataRangeStartX = this.transformIndex(this.dataRangeStartIndex) - w;
  this.dataRangeEndX =
    this.transformIndex(this.dataRangeStartIndex + this.dataRangeLength - 1) +
    w;
};

BlockChartMapping.prototype.actionStart = function (index) {
  this.actionStartIndex = this.dataRangeStartIndex;
  this.actionStartLength = this.dataRangeLength;
  if (this.actionStartLength == 0) {
    this.action = "+";
  } else {
    var start = this.dataRangeStartIndex;
    var end = this.dataRangeStartIndex + this.dataRangeLength - 1;
    if (index >= start && index <= end) {
      this.action = "-";
    } else {
      this.action = "+";
    }
  }
};

BlockChartMapping.prototype.doAction = function (start, end) {
  var actionIndex0 = Math.min(start, end);
  var actionIndex1 = Math.max(start, end);

  var startIndex0 = this.actionStartIndex;
  var startIndex1 = this.actionStartIndex + this.actionStartLength - 1;

  if (this.action == "+") {
    if (this.actionStartLength == 0) {
      this.dataRangeStartIndex = actionIndex0;
      this.dataRangeLength = actionIndex1 - actionIndex0 + 1;
    } else {
      var index0 = Math.min(actionIndex0, startIndex0);
      var index1 = Math.max(actionIndex1, startIndex1);

      if (
        index1 - index0 + 1 <=
        actionIndex1 - actionIndex0 + 1 + this.actionStartLength
      ) {
        this.dataRangeStartIndex = index0;
        this.dataRangeLength = index1 - index0 + 1;
      }
    }
  } else {
    if (
      actionIndex1 >= startIndex1 &&
      startIndex0 <= actionIndex0 &&
      actionIndex0 <= startIndex1
    ) {
      this.dataRangeStartIndex = startIndex0;
      this.dataRangeLength = actionIndex0 - startIndex0;
    } else if (
      actionIndex0 <= startIndex0 &&
      startIndex0 <= actionIndex1 &&
      actionIndex1 <= startIndex1
    ) {
      this.dataRangeStartIndex = actionIndex1 + 1;
      this.dataRangeLength = startIndex1 - actionIndex1;
    }
  }
};

BlockChartMapping.prototype.setDrawAreaSize = function (width, height) {
  this.drawAreaWidth = width;
  this.drawAreaHeight = height;
};

BlockChartMapping.prototype.setPadding = function (left, right, top, bottom) {
  this.paddingLeft = left;
  this.paddingRight = right;
  this.paddingTop = top;
  this.paddingBottom = bottom;
};

BlockChartMapping.prototype.setDataRange = function (startIndex, length) {
  this.dataRangeStartIndex = startIndex;
  this.dataRangeLength = length;
};

BlockChartMapping.prototype.setDataMinMax = function (minValue, maxValue) {
  this.dataMinValue = minValue;
  this.dataMaxValue = maxValue;
};

BlockChartMapping.prototype.transformIndex = function (index) {
  var width = this.drawAreaWidth - this.paddingLeft - this.paddingRight - 1;
  var unitWidth = this.dataLength ? width / this.dataLength : 0;
  var result = this.paddingLeft + unitWidth * (index + 0.5);

  return Math.round(result);
};

BlockChartMapping.prototype.unTransformIndex = function (x) {
  var width = this.drawAreaWidth - this.paddingLeft - this.paddingRight - 1;
  var unitWidth = this.dataLength ? width / this.dataLength : 0;
  var result = (x - this.paddingLeft) / unitWidth - 0.5;

  return result;
};

BlockChartMapping.prototype.transformValue = function (v, vAxis) {
  var max = this.dataMaxValue;
  var min = this.dataMinValue;

  if (max == min) {
    return this.paddingTop;
  }

  var height = this.drawAreaHeight - this.paddingTop - this.paddingBottom - 1;
  var result = this.paddingTop + (height * (max - v)) / (max - min);

  return Math.round(result);
};

BlockChartMapping.prototype.unTransformValue = function (y) {
  var max = this.dataMaxValue;
  var min = this.dataMinValue;

  var height = this.drawAreaHeight - this.paddingTop - this.paddingBottom - 1;
  var result = max - ((y - this.paddingTop) * (max - min)) / height;

  return result;
};

BlockChartMapping.prototype.getUnitWidth = function () {
  var width = this.drawAreaWidth - this.paddingLeft - this.paddingRight - 1;
  var unitWidth = this.dataLength ? width / this.dataLength : 0;

  return unitWidth;
};

var BlockChartUtil = function () {};

BlockChartUtil.prototype.attachTouchEvent = function (
  eventTarget,
  actionTarget
) {
  actionTarget.eventTarget = eventTarget;

  if ("ontouchstart" in window) {
    actionTarget.ontouchstart = this.onTouchEventStart;
    actionTarget.ontouchmove = this.onTouchEventMove;
    actionTarget.ontouchend = this.onTouchEventEnd;
  } else {
    actionTarget.onmousedown = this.onTouchEventStart;
    actionTarget.onmousemove = this.onTouchEventMove;
    actionTarget.onmouseover = this.onTouchEventMove;
    // actionTarget.onmouseout = this.onTouchEventOut;
    actionTarget.onmouseleave = this.onTouchEventEnd;
    actionTarget.onmouseup = this.onTouchEventEnd;
  }
};

BlockChartUtil.prototype.onTouchEventStart = function (event) {
  if (this.eventTarget != null && this.eventTarget.onTouchEvent != null) {
    var util = new BlockChartUtil();
    var cursorCoords = util.getCursorCoords(event, this);
    if (cursorCoords == null) return true;

    return this.eventTarget.onTouchEvent(this, "touchstart", cursorCoords);
  }

  return true;
};

BlockChartUtil.prototype.onTouchEventMove = function (event) {
  if (this.eventTarget != null && this.eventTarget.onTouchEvent != null) {
    var util = new BlockChartUtil();
    var cursorCoords = util.getCursorCoords(event, this);
    if (cursorCoords == null) return true;

    return this.eventTarget.onTouchEvent(this, "touchmove", cursorCoords);
  }

  return false;
};

BlockChartUtil.prototype.onTouchEventOut = function (event) {
  if (this.eventTarget != null && this.eventTarget.onTouchEvent != null) {
    return this.eventTarget.onTouchEvent(this, "touchout", null);
  }

  return true;
};

BlockChartUtil.prototype.onTouchEventEnd = function (event) {
  if (this.eventTarget != null && this.eventTarget.onTouchEvent != null) {
    return this.eventTarget.onTouchEvent(this, "touchend", null);
  }

  return true;
};

BlockChartUtil.prototype.getCursorCoords = function (event, target) {
  if ("ontouchstart" in window) {
    if (event.touches) {
      if (event.touches.length > 1) {
        return null;
      }
      event = event.touches[0];
    }
  }
  event = event || window.event;
  var element = target;
  var doc = document.documentElement;
  var body = document.body;
  var x =
    window.Event && event.pageX != undefined
      ? event.pageX
      : event.clientX +
        ((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
        ((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
  var y =
    window.Event && event.pageY != undefined
      ? event.pageY
      : event.clientY +
        ((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
        ((doc && doc.clientTop) || (body && body.clientTop) || 0);

  var xPosition = 0;
  var yPosition = 0;

  while (element) {
    xPosition += element.offsetLeft + element.clientLeft;
    yPosition += element.offsetTop + element.clientTop;
    element = element.offsetParent;
  }
  x -= xPosition;
  y -= yPosition;

  element = target;
  xPosition = 0;
  yPosition = 0;
  while (element != body) {
    xPosition += element.scrollLeft;
    yPosition += element.scrollTop;
    element = element.parentNode;
  }
  x += xPosition;
  y += yPosition;
  return { x: x, y: y, ax: x, ay: y };
};

var BlockChartDrawUtil = function () {};

BlockChartDrawUtil.createCanvas = function (parentDiv, w, h) {
  var canvas = document.createElement("canvas");
  parentDiv.appendChild(canvas);
  var ctx = canvas.getContext("2d");

  var devicePixelRatio = window.devicePixelRatio || 1;
  var backingStoreRatio =
    ctx.webkitBackingStorePixelRatio ||
    ctx.mozBackingStorePixelRatio ||
    ctx.msBackingStorePixelRatio ||
    ctx.oBackingStorePixelRatio ||
    ctx.backingStorePixelRatio ||
    1;

  var ratio = devicePixelRatio / backingStoreRatio;
  BlockChartDrawUtil.ratio = ratio;
  canvas.width = w * ratio;
  canvas.height = h * ratio;
  canvas.style.width = w + "px";
  canvas.style.height = h + "px";
  ctx.scale(ratio, ratio);

  return { canvas: canvas, ctx: ctx, width: w, height: h };
};

BlockChartDrawUtil.clear = function (canvas) {
  canvas.ctx.clearRect(0, 0, canvas.width, canvas.height);
};

BlockChartDrawUtil.line = function (
  canvas,
  x1,
  y1,
  x2,
  y2,
  lineColor,
  lineWidth,
  strokeDasharray
) {
  var ctx = canvas.ctx;
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  if (strokeDasharray != null) {
    ctx.dashedLine(x1, y1, x2, y2, strokeDasharray);
  } else {
    ctx.lineTo(x2, y2);
  }
  ctx.strokeStyle = lineColor;
  ctx.lineWidth = lineWidth;
  ctx.stroke();
};

BlockChartDrawUtil.drawPoint = function (canvas, x, y, color, fillColor, r) {
  var ctx = canvas.ctx;
  ctx.beginPath();
  ctx.arc(x, y, r - 1, 0, 2 * Math.PI);
  ctx.strokeStyle = color;
  ctx.lineWidth = 2 * BlockChartDrawUtil.ratio;
  ctx.stroke();
  ctx.fillStyle = fillColor;
  ctx.fill();
};

BlockChartDrawUtil.path = function (canvas, p, w, lineColor) {
  if (p.length == 0) return;
  var ctx = canvas.ctx;
  ctx.beginPath();
  ctx.strokeStyle = lineColor;
  ctx.lineWidth = w;

  ctx.moveTo(p[0].x, p[0].y);
  for (var i = 1; i < p.length; i++) {
    ctx.lineTo(p[i].x, p[i].y);
  }
  ctx.stroke();
};

BlockChartDrawUtil.pathFill = function (
  canvas,
  p,
  w,
  lineColor,
  fillColor,
  fillOpacity
) {
  if (p.length == 0) return;

  fillOpacity = fillOpacity || 1;
  var ctx = canvas.ctx;
  ctx.beginPath();
  ctx.strokeStyle = lineColor;
  ctx.lineWidth = w;

  ctx.moveTo(p[0].x, p[0].y);
  for (var i = 1; i < p.length; i++) {
    ctx.lineTo(p[i].x, p[i].y);
  }
  ctx.closePath();
  if (w > 0 && lineColor != null) {
    ctx.stroke();
  }
  ctx.fillStyle = fillColor;
  fillOpacity = fillOpacity || 1;
  if (fillOpacity != 1) {
    ctx.globalAlpha = fillOpacity;
  }
  ctx.fill();
};

BlockChartDrawUtil.fillText = function (canvas, x, y, t, textColor, align) {
  var ctx = canvas.ctx;
  ctx.fillStyle = textColor;
  ctx.font = "14px Arial";

  var w = ctx.measureText(t).width;
  var offset = 0;
  if (align == "center") {
    offset = w / 2;
  } else if (align == "right") {
    offset = w;
  }
  ctx.fillText(t, x - offset, y);
};

BlockChartDrawUtil.measureText = function (canvas, t) {
  var ctx = canvas.ctx;
  ctx.font = "14px Arial";

  return ctx.measureText(t).width;
};

BlockChartDrawUtil.roundRect = function (
  canvas,
  x,
  y,
  w,
  h,
  r,
  lineColor,
  fillColor
) {
  var ctx = canvas.ctx;
  if (w < 2 * r) {
    r = w / 2;
  }
  if (h < 2 * r) {
    r = h / 2;
  }
  ctx.beginPath();
  ctx.strokeStyle = lineColor;
  ctx.fillStyle = fillColor;
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.stroke();
  ctx.closePath();
  ctx.fill();
};
